interface IStickyBannerprops {
  customClass?: string;
  children: React.ReactNode;
}

const StickyBanner: React.FC<IStickyBannerprops> = ({
  customClass,
  children,
}) => {
  return (
    <div
      className={`${customClass}  bg-brightOrange flex flex-1 mt-2 w-full justify-center p-[5px] z-30 text-white text-medium text-sm`}
    >
      {children}
    </div>
  );
};

export default StickyBanner;
